import { Component } from 'react';
import CollapsibleBox from '../utils/CollapsibleBox';
import { style } from 'typestyle';
import Theme from '../theme/Theme';
import SideDivider from '../layout/SideDivider';

class CollapsibleDefault extends Component {
    render() {
        let title = this.props.title, summary = this.props.summary ?? '', width = this.props.width ?? (SideDivider.bodyWidth - 40) + 'px';
        let children = this.props.children?.length > 0 ? this.props.children : this.props.children ? [this.props.children] : [];

        return (
            <CollapsibleBox opened={false}
                className={'loadorder-collapsibleboxd ' +
                    style({
                        background: Theme.col1('whitesmoke'),
                        borderRadius: '1rem',
                        color: Theme.col0()
                    })
                }
                style={{ width, margin: this.props.collapsed ? '2px auto' : '1rem auto' }}

                title={
                    <div className='loadorder-title'
                        style={{
                            height: '100%', display: 'flex', color: Theme.col0('steelblue'), // ,
                            justifyContent: 'center', alignItems: 'center', fontWeight: '700',
                        }}
                    >
                        <span style={{ fontWeight: '900' }}>{title}</span>
                    </div>
                }

                headerStyle={{
                    width: `calc(${width} - 2rem)`,
                    background: Theme.col1('whitesmoke'),
                    color: Theme.col0(),
                }}

                summary={
                    <span className='loadorder-summary'
                        style={{
                            margin: '0 1rem',
                            fontSize: '0.8rem',
                            color: Theme.col2('#550')
                        }}
                    >
                        {!Array.isArray(summary) ? summary : Card.renderCards('', summary)}
                    </span>
                }

                bodyStyle={{
                    ...this.props.style, ...this.stl, marginTop: '0',
                    borderRadius: /*this.props.collapsed ? '0' :*/ '0 0 1rem 1rem',
                    width: `calc(${width} - 2rem)`,
                    background: Theme.col1('whitesmoke'),
                }}
            >
                {this.props.body}
                {...children}
            </CollapsibleBox>
        );
    }
}


export default CollapsibleDefault;